var exports = {
  "g": "CommentActionsIconButton__rdmp8b",
  "E": "CommentActionsListItem__-wnCB-",
};

module.exports = exports;
